import { FunctionComponent } from 'react';
import preval from 'preval.macro';

import './BottomNavigation.scss';
import { ContentLink } from './ContentLink';

type BottomNavigationProps = {
  currentModal: string;
  setCurrentModal: (modalName: string) => void;
};

export const BottomNavigation: FunctionComponent<BottomNavigationProps> = ({
  currentModal,
  setCurrentModal,
}: BottomNavigationProps) => {
  const buildStamp = preval`module.exports = new Date().toLocaleString();`;

  return (
    <div className="BottomNavigation">
      <ContentLink
        text="About"
        currentModal={currentModal}
        setCurrentModal={setCurrentModal}
      ></ContentLink>
      <ContentLink
        text="Contact"
        currentModal={currentModal}
        setCurrentModal={setCurrentModal}
      ></ContentLink>
      <ContentLink
        text="Privacy"
        currentModal={currentModal}
        setCurrentModal={setCurrentModal}
      ></ContentLink>
      <div className="fine-print">
        <span>Copyright &copy; 2011- ShareThePlay.com</span>
        <span>Built on {buildStamp}</span>
      </div>
    </div>
  );
};
